import { useEffect } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import PageNotFound from '../components/pageNotFound/PageNotFound'
import { HOME_URL, LOG_IN_URL, SETTINGS_URL } from '../constants/navigation'
import requireLanguage from '../hoc/requireLanguage'
import { getCurrentUser } from '../store/actions/auth'
import { isAuthenticated } from '../util/account.helpers'
import { welcomeScreenLink } from '../util/siteLink.helpers'

const PageNotFoundContainer = ({ authState, getCurrentUser }) => {
  const checkIsAuthenticated = isAuthenticated(authState)
  const navigate = useNavigate()

  useEffect(() => {
    if (!checkIsAuthenticated) {
      getCurrentUser()
    }
  }, [checkIsAuthenticated, getCurrentUser])

  const handleBackToHome = () => {
    navigate(checkIsAuthenticated ? HOME_URL : welcomeScreenLink(), {
      replace: true
    })
  }

  const handleCancelLink = () => {
    navigate(checkIsAuthenticated ? SETTINGS_URL : LOG_IN_URL, {
      replace: true
    })
  }

  if (checkIsAuthenticated) {
    return (
      <PageNotFound
        auth
        onBackToHome={handleBackToHome}
        onCancelLink={handleCancelLink}
      />
    )
  } else {
    return (
      <PageNotFound
        onBackToHome={handleBackToHome}
        onCancelLink={handleCancelLink}
      />
    )
  }
}

const mapStateToProps = ({ authReducer }) => {
  const { authProfile } = authReducer
  return {
    authState: authProfile.authState
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCurrentUser
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(requireLanguage(PageNotFoundContainer))
